import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { MazeScene } from "./MazeScene";
import { AudioManager } from "../../AudioManager";
import { MazeManager } from "./MazeManager";

export class GUI extends Phaser.GameObjects.Container {

    private pauseButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.pauseButton = new Button(this.scene, GameConstants.GAME_WIDTH - 30 * GameVars.correctionScale, 30 * GameVars.scaleY * GameVars.correctionScale, "texture_atlas_1", "btn_pause_off", "btn_pause_on");
        this.pauseButton.setInflationTween(1.1 * GameVars.correctionScale, 1 * GameVars.correctionScale, GameVars.scaleY * GameVars.correctionScale);
        this.pauseButton.onUp(this.onClickPause, this);
        this.pauseButton.setScrollFactor(0);
        this.add(this.pauseButton);
    }

    public paused(): void {

        this.pauseButton.visible = false;
    }

    public resumed(): void {

        this.pauseButton.visible = true;
    }

    private onClickPause(): void {

        MazeManager.pauseGame();

        AudioManager.playSound("click");
    }
}
